import React, { useEffect } from 'react';
import { CertificateDetailWrapper } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export const CertificateDetailPage = (): React.ReactElement => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificateDetailWrapper />
    </div>
  );
};
